// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xyTj","toggleWrap":"styles_toggleWrap__2puqN","content":"styles_content__3HX38","selectAreaCode":"styles_selectAreaCode__3MyU9"};